import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step4Props, useStep4Props } from '../types'
import useStep4Form from './useStep4.form'
import useStep4FormOptions from './useStep4.form.options'
import useStep4FormConditions from './useStep4.form.conditions'

const useStep4 = (props: useStep4Props): Step4Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const formProps = useStep4Form(activationObject)
    const options = useStep4FormOptions(formProps.form, activationObject)
    const conditionsProps = useStep4FormConditions(formProps.form, activationObject)

    return {
        ...props,
        activationObject,
        form: formProps,
        options: options,
        conditions: conditionsProps,
        isUpdating,
    }
}

export default useStep4
